import { cachebuster } from "../../../utilities/cachebuster";
import { getPageId } from "../state/pageId";
export function refresh() {
    // TODO: refresh mockdate?
    // TODO: avoid duplicate refreshes? like when a gospel meeting and sunday morning collide
    const url = new URL(window.location.href);
    url.searchParams.set("pageId", getPageId());
    window.location.href = cachebuster(url.href); // refreshes the page
}
